module.exports = __webpack_public_path__ + "img/search-salon-2020.deffcf82.jpg";